import { cliente } from "../http/cliente";
import type { DashboardOut } from "./tipos";

/*
 * Fetcher do dashboard (Tela 1 — landing em `/`).
 *
 * Camada fina sobre o `cliente` HTTP (CP-C): injeta Bearer, trata refresh/401/503
 * e normaliza erro em `ErroHttp`. NÃO trata erro — propaga a rejeição do
 * `cliente` para o TanStack Query (hooks em `./hooks`) decidir.
 *
 * `baseURL` do cliente já é `/api`, então o path aqui é relativo a ela.
 * `horizonte` vai sempre como query param. `empresa_id` é INCLUÍDO apenas quando
 * há empresa selecionada (`empresaId !== null`); omiti-lo significa visão GRUPO
 * (consolidado), que o backend só autoriza para usuário irrestrito.
 */

/**
 * `GET /api/dashboard?horizonte=N[&empresa_id=UUID]`.
 *
 * `empresaId === null` → visão GRUPO (sem `empresa_id` nos params). `empresaId`
 * presente → visão da empresa (param incluído). O `horizonte` é sempre enviado;
 * o backend valida a faixa.
 */
export async function buscarDashboard(
  empresaId: string | null,
  horizonte: number,
): Promise<DashboardOut> {
  const params: Record<string, string | number> = { horizonte };
  if (empresaId !== null) {
    params.empresa_id = empresaId;
  }
  const resposta = await cliente.get<DashboardOut>("/dashboard", { params });
  return resposta.data;
}
